export default [
    { value: 1, label: 'ENERO' },
    { value: 2, label: 'FEBRERO' },
    { value: 3, label: 'MARZO' },
    { value: 4, label: 'ABRIL' },
    { value: 5, label: 'MAYO' },
    { value: 6, label: 'JUNIO' },
    { value: 7, label: 'JULIO' },
    { value: 8, label: 'AGOSTO' },
    { value: 9, label: 'SETIEMBRE' },
    { value: 10, label: 'OCTUBRE' },
    { value: 11, label: 'NOVIEMBRE' },
    { value: 12, label: 'DICIEMBRE' }
]


// WEBPACK FOOTER //
// ./src/common/constants/months.js